
import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import styled from "styled-components";
import ActionsDropdown from "../ActionsDropdown";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(even) {
    background-color: #ffffff; /* Light gray for even rows */
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #ffffff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};

function Studyingstudents() {
  const [responseData, setResponseData] = useState([]);
  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const [loading, setLoading] = useState(false);
  const [filteredDatacompleted, setFilteredDatacompleted] = useState([]);
  const navigate = useNavigate();

  const data = useMemo(() => {
    return responseData.map((item) => ({
      _id: item._id,
      admission_date: item.admission_date,
      duraction: item.duraction,
      batch_timings: item.batch_timings,
      father_name: item.father_name,
      qualification: item.qualification,
      discount: item.discount,
      fees: item.fees,
      student_type: item.student_type,
      payment_type: item.payment_type,
      roll_no: item.roll_no,
      photo_upload: item.photo_upload,
      id_proof: item.id_proof,
      leads_id: item.leads_id,
      course_id: item.course_id,
      date_of_birth: item.date_of_birth,
      trainer: item.trainer,
      register_no: item.register_no,
      placement: item.placement,
      duraction_time: item.duraction_time,
      branch_lead: {
        _id: item.branch_lead?._id ?? null,
        branch_id: item.branch_lead?.branch_id ?? "",
        branch_name: item.branch_lead?.branch_name ?? "",
      },
      student_name_lead: item.student_name_lead,
      mobile_no_lead: item.mobile_no_lead,
      email_lead: item.email_lead,
      Prefered_course_lead: item.Prefered_course_lead,
      purpose_enquiry_lead: item.purpose_enquiry_lead,
      Enquiry_date_lead: item.Enquiry_date_lead,
      Source_type_lead: item.Source_type_lead,
      contact_type_lead: item.contact_type_lead,
      assign_staff_lead: item.assign_staff_lead,
      referal_candidate_name_lead: item.referal_candidate_name_lead,
      referal_candidate_lead: item.referal_candidate_lead,
      followups_time_lead: item.followups_time_lead,
      followups_date_lead: item.followups_date_lead,
      status_time_lead: item.status_time_lead,
      followups_status_lead: item.followups_status_lead,
      followups_notes_lead: item.followups_notes_lead,
      interest_lead: item.interest_lead,
    }));
  }, [responseData]);

  const [rolename, setrolename] = useState([]);
  useEffect(() => {
    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);


  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: "S.No",
        id: "serialNo",
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: "Student",
        accessor: "student_name_lead",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Course",
        accessor: "Prefered_course_lead",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Mobile",
        accessor: "mobile_no_lead",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Fees",
        accessor: "fees",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
    ];

    // **Conditionally Modify Columns Based on Role**
    if (rolename === "Branches") {
      baseColumns.splice(1, 0, {
        Header: "Branch",
        accessor: "branch_lead.branch_name",
        Cell: ({ row }) => {
          const branch = row.original.branch_lead;
          return branch && branch.branch_name ? branch.branch_name : "-";
        },
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      });
    }

    return baseColumns;
  }, [rolename]); // Dependency array ensures it updates when `rolename` changes


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const updateinfo = (id) => {
    navigate(`/StudentInfo/${id}`);
  };

  const [updateData, setUpdateData] = useState({
    student_name: "",
    total_fees: "",
    paid: "",
    balance: "",
    status: "",
    completed: "",
    course_status: "",
    completed_date: "",
    roll_no: "",
    photo_upload: "",
    id_proof: "",
  });

  useEffect(() => {
    fetchData();
    gettoken();
    getprevillages();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  // Assuming response1212 and invoicedetails1212 are already defined

  // Step 1: Loop through the invoicedetails data and find the matching students
  // const matchedStudents = invoicedetails.data
  // .map(invoice => {
  //   // Find the student whose _id matches the studyingstudent field in the invoice
  //   const matchedStudent = response.data.find(student => student._id === invoice.studyingstudent);

  //   return matchedStudent || null; // Return matched student or null if not found
  // })
  // .filter(student => student !== null); // Filter out null values
  // Assuming response1212 and invoicedetails1212 are already defined



  //   else {
  //     // Code for when branch_name is NOT "Branches"
  //     console.log("Branch name is not 'Branches'");

  //     const username = localStorage.getItem("username");
  //     const internal_emp = localStorage.getItem("internal_emp");

  //     // Fetch the student data based on branch ID from localStorage
  //     const response = await axios.get(apiUrl + "/student", {
  //         params: { data: localStorage.getItem("branch_id") },
  //     });

  //     const invoicedetails = await axios.get(apiUrl + "/invoice_details", {});
  //     console.log("response1212 - Else", response);
  //     console.log("invoicedetails1212 - Else", invoicedetails);

  //     // Fetch staff data
  //     const responsess = await axios.get(apiUrl + "/staff", {});

  //     // Filter staff based on the logged-in user's empid or internal_emp
  //     const filteredStaff = responsess.data.filter(
  //         (item) => item.assign_staff_lead?.empid === username || item.assign_staff_lead?.empid === internal_emp
  //     );
  //     console.log("filteredStaff - Else", filteredStaff);

  //     // Get the student IDs from filtered staff assignments
  //     const assignedStudentIds = filteredStaff.map(staff => staff._id);

  //     // Filter invoice details for students with paid amounts > 0
  //     const invoicedStudents = invoicedetails.data.filter(invoice => parseFloat(invoice.paid) > 0);
  //     console.log("invoicedStudents - Else", invoicedStudents);

  //     // Now map invoicedStudents to their corresponding student details based on filtered staff
  //     const matchedStudents = invoicedStudents.map(invoice => {
  //         // Find the student matching the invoice
  //         const matchedStudent = response.data.find(student => student._id === invoice.studyingstudent);

  //         // Check if this student is assigned to the logged-in staff
  //         if (matchedStudent && assignedStudentIds.includes(matchedStudent._id)) {
  //             return matchedStudent;
  //         }

  //         return null;
  //     }).filter(student => student !== null); // Filter out null values

  //     console.log("Matched Students - Else", matchedStudents);

  //     // Set the matched student data to the responseData state
  //     setResponseData(matchedStudents);
  // }



  const fetchData = async () => {
    const branch_name = localStorage.getItem("branch_name");

    try {
      setLoading(true);  // Start loading

      // Check if the branch_name is "Branches"
      if (branch_name === "Branches") {
        // Logic for when branch_name is "Branches"
        const response = await axios.get(apiUrl + "/student", {
          params: { data: localStorage.getItem("branch_id") },
        });
        const invoicedetails = await axios.get(apiUrl + "/invoice_details");
        console.log("Response from student data (Branches):", response);
        console.log("Invoice details (Branches):", invoicedetails);

        const matchedStudents = invoicedetails.data
          .filter(invoice => parseFloat(invoice.paid) > 0) // Filter for invoices with paid > 0
          .map(invoice => {
            const matchedStudent = response.data.find(student => student._id === invoice.studyingstudent);
            return matchedStudent || null;
          })
          .filter(student => student !== null); // Remove nulls

        console.log("Matched Students (Branches):", matchedStudents);

        // Filter students whose course is not completed
        const filteredDatass = matchedStudents.filter(
          (item) => item.course_status !== "Completed"
        );
        setFilteredDatacompleted(filteredDatass);
        console.log("Filtered students (Not Completed) (Branches):", filteredDatass);

        // Filter students who are 'Converted' and have a callback date
        const filteredData = matchedStudents.filter(
          (item) => item.status === "Converted" && item.callbackdate !== null
        );

        // Set the state with filtered data
        setResponseData(matchedStudents.reverse());
        setFilteredData(filteredData);

      } else {
        // Logic for when branch_name is NOT "Branches"
        console.log("Branch name is not 'Branches'");

        const username = localStorage.getItem("username");
        const internal_emp = localStorage.getItem("internal_emp");

        const response = await axios.get(apiUrl + "/student", {
          params: { data: localStorage.getItem("branch_id") },
        });
        const invoicedetails = await axios.get(apiUrl + "/invoice_details");
        console.log("Response from student data (Branches):", response);
        console.log("Invoice details (Branches):", invoicedetails);

        const matchedStudents = invoicedetails.data
          .filter(invoice => parseFloat(invoice.paid) > 0) // Filter for invoices with paid > 0
          .map(invoice => {
            const matchedStudent = response.data.find(student => student._id === invoice.studyingstudent);
            return matchedStudent || null;
          })
          .filter(student => student !== null) // Remove nulls

        console.log("Matched Students (Branches):", matchedStudents);

        const filteredempid = matchedStudents.filter(
          (item) => item.assign_staff_lead?.empid === username || item.assign_staff_lead?.empid === internal_emp
        );

        // Filter students whose course is not completed
        const filteredDatass = matchedStudents.filter(
          (item) => item.course_status !== "Completed"
        );
        setFilteredDatacompleted(filteredDatass);
        console.log("Filtered students (Not Completed) (Branches):", filteredDatass);

        // Filter students who are 'Converted' and have a callback date
        const filteredData = matchedStudents.filter(
          (item) => item.status === "Converted" && item.callbackdate !== null
        );

        console.log("the filteredempid", filteredempid)
        // Set the state with filtered data
        setResponseData(filteredempid);
        setFilteredData(filteredData);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);  // Stop loading after the data is fetched or if there is an error
    }
  };



  // const fetchData = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await axios.get(apiUrl + "/student", {
  //       params: { data: localStorage.getItem("branch_id") },
  //     });
  //     const invoicedetails = await axios.get(apiUrl + "/invoice_details", {
  //     });
  //     console.log("response1212", response)
  //     console.log("invoicedetails1212", invoicedetails)


  //     const matchedStudents = invoicedetails.data
  //       .filter(invoice => parseFloat(invoice.paid) > 0) // Filter for invoices where paid > 0
  //       .map(invoice => {
  //         const matchedStudent = response.data.find(student => student._id === invoice.studyingstudent);
  //         return matchedStudent || null;
  //       })
  //       .filter(student => student !== null);


  //     console.log(matchedStudents);
  //     console.log("this123123", matchedStudents);
  //     console.log("Response from server student data:",response.data.reverse());
  //     console.log("Response from server length:", response.data.length);

  //     const filteredDatass = matchedStudents.filter(
  //       (item) => item.course_status !== "Completed"
  //     );
  //     setFilteredDatacompleted(filteredDatass);
  //     console.error("Error fetching data: filteredDatass", filteredDatass);

  //     const filteredData = matchedStudents.filter(
  //       (item) => item.status === "Converted" && item.callbackdate !== null
  //     );
  //     setResponseData(matchedStudents);
  //     setFilteredData(filteredData);
  //   } catch (error) {
  //     console.error("Error fetching data:", error.message);
  //   }
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 1000);
  // };

  const gettoken = async () => {
    const token = localStorage.getItem("token");
    // console.log("the toekn in the localStorage is : ",token);
    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);
      // setResponseData(response.data);

      console.log("The role id is : ", response.data.detail.rolename);
      setroleid(response.data.detail.rolename);
      console.log("the role_id is : ", role_id);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      // getpages();

      if (id) {
        // try {
        //     const response = await axios.get(apiUrl + `/role_2/${id}`);
        //     console.log("the reponse list in brach is : ", response.data.modules);
        //     const modules = response.data.modules;
        //     const filtered_access = modules.filter(item => item.name == "Branch")
        //     console.log("the modules is : ", filtered_access[0].actions);
        //     setprevillages(filtered_access[0].actions);
        //     console.log("the assigned previllages is : ", previllages.add);
        // } catch (error) {
        //     console.error("Error fetching data:", error.message);
        // }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);

    const total_previlages = username.modules;

    const new_enquiry = total_previlages.find(
      (item) => item.name == "Studying Students"
    );

    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions);
  };

  const [updateid, setUpdateId] = useState([]);

  const handleUpdate = async (_id) => {
    setUpdateShowModal(true);
    const responseid = await axios.get(`${apiUrl}/student/${_id}`);
    console.log(responseid.data[0], "responseid--", _id);
    const data = responseid.data[0];
    console.log("the data was", data)
    setUpdateId({
      _id: _id,
      student_name: data.student_name_lead,
      roll_no: data.roll_no,
      fees: data.fees,
      course_status: data.course_status,
    });
    console.log("the data wasssssss", updateid)
  };

  function handleUpdateRegister(id) {
    if (previllages.edit || previllages.all) {
      navigate(`/Registrationupdate/${id}`);



    } else {
      toast.error("You don't have the permission to update");
    }
  }

  // const handleupdatesubmit = async (e, id) => {
  //   e.preventDefault(); // This prevents the default form submission behavior

  //   try {
  //     const formDataupdate = {

  //       course_status: updateid.course_status,
  //     };
  //     console.log("the update submit data", id, updateid.course_status);

  //     // if (updateData.photo_upload) formData.append('photo_upload', updateData.photo_upload);
  //     // if (updateData.id_proof) formData.append('id_proof', updateData.id_proof);

  //     const response = await axios.put(
  //       apiUrl + `/student/${String(id)}`,
  //       formDataupdate,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );
  //     console.log('Form data before sending:', formDataupdate);


  //     console.log("response for update", response);
  //     setUpdateShowModal(false);
  //     toast.success("update successfully!");
  //     fetchData();
  //   } catch (error) {
  //     console.error("Error updating data:", error.message);
  //   }
  // };



  // const handleupdatesubmit = async (e, id) => {
  //   e.preventDefault(); // This prevents the default form submission behavior

  //   try {
  //     // Ensure that the `updateid` contains the necessary data
  //     if (!updateid || !updateid.course_status || !updateid._id) {
  //       console.error("Missing course status in update data.");
  //       return;
  //     }

  //     // Prepare form data with default values for any missing fields
  //     const formDataupdate = {
  //       student_name: updateid.student_name,
  //       roll_no: updateid.roll_no,
  //       fees: updateid.fees,
  //       course_status: updateid.course_status || "", // Default empty string if undefined
  //   };

  //     console.log("The update submit data:", id, updateid.course_status);

  //     // Send the data to the backend using axios
  //     console.log("Response for update:", formDataupdate);


  //     const response = await axios.put(
  //       apiUrl + `/student/${id}`,
  //       formDataupdate,

  //       {
  //         // headers: {
  //         //   "Content-Type": "application/json", // Correct header for JSON data
  //         // },
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     // Handle the successful response
  //     console.log("Response for update:", response);

  //     // Close the modal (if applicable)
  //     setUpdateShowModal(false);

  //     // Show success toast
  //     toast.success("Update successful!");

  //     // Call the fetchData function to refresh the data (if applicable)
  //     fetchData();
  //   } catch (error) {
  //     console.error("Error updating data:", error.message);

  //     // Handle any errors during the update process
  //     toast.error("An error occurred while updating. Please try again.");
  //   }
  // };

  const handleupdatesubmit = async (e, id) => {
    e.preventDefault(); // Prevent default form submission behavior

    try {
      // Ensure necessary fields are available
      if (!updateid || !updateid.course_status || !updateid._id) {
        console.error("Missing required data in update.");
        return;
      }

      // Prepare form data with default values for any missing fields
      const formDataupdate = {
        student_name: updateid.student_name,
        roll_no: updateid.roll_no,
        fees: updateid.fees,
        course_status: updateid.course_status || "", // Default empty string if undefined
      };

      console.log("The update submit data:", id, formDataupdate);

      // Send the data to the backend using axios
      const response = await axios.put(
        `${apiUrl}/student/${id}`,
        formDataupdate,
        {
          headers: {
            "Content-Type": "application/json", // Use this header for JSON data
          },
        }
      );

      console.log("Response for update:", response);

      // Close the modal and show success toast
      setUpdateShowModal(false);
      toast.success("Update successful!");

      // Call the fetchData function to refresh the data (if applicable)
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error);
      console.error("Error details:", error.response?.data || error.message);
      toast.error("An error occurred while updating. Please try again.");
    }
  };


  const handleDelete = async (_id) => {
    try {
      const response = await axios.delete(apiUrl + `/student/${getdeleteid}`);
      console.log("delete data ", response);
      toast.error("Delete successfully!");
      setDeleteShowModals(false);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const handleOpenModal = async (_id, student_name_lead) => {
    if (previllages.all || previllages.delete) {
      console.log(" the id", _id);
      console.log(" the studentname", student_name_lead);
      setdeleteid(_id);
      setdeletename(student_name_lead);
      setDeleteShowModals(true);
    } else {
      toast.error("You don't have the permission to delete");
    }
  };

  // the pagination ---------------------------------------------------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const filtered = rows.filter((item) =>
    Object.values(item).some(
      (value) =>
        (typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  // const createPagination = () => {
  //   let liTag = [];

  //   // Previous Page Button
  //   liTag.push(
  //     <li
  //       className={`page-item ${!canPreviousPage ? "disabled" : ""}`}
  //       key="prev"
  //     >
  //       <button
  //         className="page-link"
  //         onClick={() => canPreviousPage && gotoPage(state.pageIndex - 1)}
  //         disabled={!canPreviousPage}
  //       >
  //         <FaAngleLeft /> Prev
  //       </button>
  //     </li>
  //   );

  //   // Page Numbers
  //   for (let plength = 1; plength <= pageCount; plength++) {
  //     liTag.push(
  //       <li
  //         key={plength}
  //         className={`page-item ${
  //           plength === state.pageIndex + 1 ? "active" : ""
  //         }`}
  //       >
  //         <button
  //           className="page-link"
  //           onClick={() => gotoPage(plength - 1)} // 0-indexed
  //         >
  //           {plength}
  //         </button>
  //       </li>
  //     );
  //   }

  //   // Next Page Button
  //   liTag.push(
  //     <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
  //       <button
  //         className="page-link"
  //         onClick={() => canNextPage && gotoPage(state.pageIndex + 1)}
  //         disabled={!canNextPage}
  //       >
  //         Next <FaAngleRight />
  //       </button>
  //     </li>
  //   );

  //   return liTag;
  // };

  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`} key="prev">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === 0 ? "active" : ""}`} key={0}>
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === 1 ? "active" : ""}`} key={1}>
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 3, currentPage + 1); i++) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 2 ? "active" : ""}`} key={totalPages - 2}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 2)}>
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 1 ? "active" : ""}`} key={totalPages - 1}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 1)}>
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };

  //////////// complate date show code /////////////////////

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    console.log("the select status", selectedStatus);
    setUpdateData({ ...updateData, completed: selectedStatus });

    if (selectedStatus === "Completed") {
      setShowCallbackDate(true);
    } else {
      setShowCallbackDate(false);
      setUpdateData((prevData) => ({
        ...prevData,
        selectedStatus: "",
      }));
    }
  };

  const [showCallbackDate, setShowCallbackDate] = useState(false);



  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-3">
            <div className="col-lg-11">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="" className="text-secondary dashBoard_text">
                <b>Enrollment / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>Studying Student</b>
              </Link>
            </div>
          </div>
        </div>
        {/* <div className="row">
          
        </div> */}

        {/* ------------ search and per page ----------------------------*/}

        <div className="mb-1 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1">
              <div>
                <h5>Studying Student</h5>
              </div>
            </div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">

              {/* </div>

            <div className="col-lg-3 col-md-4 col-sm-7"> */}
              <div className="w-full flex-1 me-5">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""} // Use the globalFilter value
                      onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                    />
                  </div>
                </form>
              </div>
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show : </label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'All') {
                        setPageSize(data.length);  // 'data' should be your dataset containing all the entries
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option> {/* Add 'All' option */}
                    {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">{column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}
                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={{
                        edit: previllages.edit,
                        delete: previllages.delete,
                      }}
                      onUpdateStatus={(id, row) =>
                        handleUpdate(id, row)
                      }
                      onEdit={(id) => {
                        setLoading(true);
                        setTimeout(() => {
                          handleUpdateRegister(id);
                          setLoading(false);
                        }, 1000);
                      }}
                      onInfo={(id) => {
                        setLoading(true);
                        setTimeout(() => {
                          updateinfo(id);
                          setLoading(false);
                        }, 1000);
                      }}
                      onDelete={(id, row) =>
                        handleOpenModal(id, row.student_name_lead)
                      }
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        {/* ----------------update */}
        {/* {console.log("updateid77", updateid)} */}

        <Modal
          show={isUpdateshowModal}
          onHide={() => setUpdateShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti"> Update Studying Students</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="floating-label">
              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  disabled
                  placeholder=""
                  value={updateid.student_name}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      student_name_lead: e.target.value,
                    })
                  }
                  required
                />
                <label className={updateData.student_name_lead ? "filled" : ""}>
                  Student name
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  disabled
                  placeholder=""
                  value={updateid.roll_no}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, roll_no: e.target.value })
                  }
                  required
                />
                <label className={updateData.roll_no ? "filled" : ""}>
                  Roll No
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  disabled
                  placeholder=""
                  value={updateid.fees}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, paid: e.target.value })
                  }
                  required
                />
                <label className={updateData.paid ? "filled" : ""}>Fees</label>
              </div>

              <div className="floating-label">
                <select
                  className="form-control"
                  value={updateid.course_status || ""}
                  onChange={(e) =>
                    setUpdateId({ ...updateid, course_status: e.target.value })
                  }
                  required
                >
                  <option value="">Select status</option>
                  <option value="Completed">Completed</option>
                  {/* <option value="Studying">Studying</option> */}
                  <option value="Discontinue">Discontinue</option>
                </select>

                <label className={updateid.course_status ? "filled" : ""}>
                  Selected Status
                </label>
              </div>

              {/* <div className="floating-label">
                            {showCallbackDate && ( // Show the callback date field if 'Callback' status is selected
                                <div className="form-group mt-2">

                                    <input className="form-control" type="date" value={updateData.completed_date} onChange={(e) => setUpdateData({ ...updateData, completed_date: e.target.value })} required />
                                </div>
                            )}

                            <label className={updateData.completed_date ? "filled" : ""}>
                            </label>
                        </div>


 */}

              {/* <div className="floating-label">
                            <input
                                className="form-control"
                                type="file"
                                onChange={(e) => setUpdateData({ ...updateData, photo_upload: e.target.files[0] })}
                                required
                            />
                            <label className={updateData.photo_upload ? "filled" : ""}>
                                Upload Photo
                            </label>
                        </div> */}

              {/* <div className="floating-label">
                            <input
                                className="form-control"
                                type="file"
                                onChange={(e) => setUpdateData({ ...updateData, photo_upload: e.target.files[0] })}
                                required
                            />
                            <label className={updateData.photo_upload ? "filled" : ""}>
                                Upload Photo
                            </label>
                        </div> */}

              {/* <div className="floating-label">
                            <input
                                className="form-control"
                                type="file"
                                // accept=".pdf,.doc,.docx,.txt"
                                onChange={(e) => setUpdateData({ ...updateData, id_proof: e.target.files[0] })}
                                required
                            />
                            <label className={updateData.id_proof ? "filled" : ""}>
                                Upload ID Proof (Document)
                            </label>
                        </div> */}

              {/* Display file name after uploading */}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={(e) => handleupdatesubmit(e, updateid._id)}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ----------------delete */}

        <Modal
          className="modal"
          show={deleteShowModals}
          onHide={handleCloseModal}
        >
          <Modal.Header>
            <p id="modeti">Are you sure you want to Delete?</p>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label d-flex">
              <h5 className="mx-1"> Student Name :</h5>{" "}
              <h5>{getdeletename} </h5>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        {/* _------------------------------pagination button -------------------------------- */}

        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {state.pageIndex + 1} of {pageCount}
              </span>
            </div>
            <div className="col-lg-5">
              <div className="mt-3 pb-5">
                <nav>
                  <ul className="pagination justify-content-center">
                    {createPagination()} {/* Pagination buttons */}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* ---------------------------------------end ---------------------------------- */}
      </div>
    </>
  );
}
export default Studyingstudents;

